module.exports = __webpack_public_path__ + "img/img6.4e8f621a.png";